import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IBaseResponse } from './IBaseResponse';
import { IPreprecatorioRejection } from '../interfaces/IPreprecatorioRejection';
import { IPrePrecatorioQuotes as IPrePrecatorioQuotes } from '../interfaces/trade/precificacao/IPrePrecatorioQuotes';

enum PrePrecatorioServiceEnum {
  getAllQuotesPrePrecatorio = "/all-quotes",
  TakeQuote = "/take-quote/",
  rejectQuote = "/reject"
}

export default class PrePrecatorioService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/pre-precatorio");
  }

  public getAllQuotesPrePrecatorio = async ():Promise<IPrePrecatorioQuotes[]> => await this.GET(PrePrecatorioServiceEnum.getAllQuotesPrePrecatorio);
  public takeQuote = async (quoteId: number): Promise<IBaseResponse> => await this.PUT(PrePrecatorioServiceEnum.TakeQuote + quoteId);
  public rejectQuote = async (data: IPreprecatorioRejection) => await this.POST(PrePrecatorioServiceEnum.rejectQuote, data);

}


// WEBPACK FOOTER //
// ./src/services/api/PrePrecatorio.service.ts